// Common service functions using fetch API instead of axios

const BASE_URL = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
// const OLD_SYS  = process.env.REACT_APP_BASE_URL;
const REACT_ADMIN = process.env.REACT_APP_REACT_ADMIN;
const handleResponse = async (response) => {
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json();
};

const handleError = (error) => {
  console.error('API Error:', error);
  throw error;
};


export const is_approval_valid = async (approval_id,token) => {
    const formData = new FormData();
    formData.append('approval_id',approval_id);   
    formData.append('user_token',token);    
    const response = await fetch(`${BASE_URL}/approval-data`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response); 
}

export const esign_request_details = async (req_token,token) => {
  const formData = new FormData();
  formData.append('req_token',req_token);   
  formData.append('user_token',token);    
  const response = await fetch(`${BASE_URL}/e-signature-details`, {
    method: 'POST',
    body: formData,
  });
  return handleResponse(response); 
}


export const getInstoCompanyTokens = async (userToken, jwtToken,profiletype) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('jwtToken', jwtToken);
    formData.append('a_profile', profiletype);
    
    const response = await fetch(`${BASE_URL}/switch-business-profile-from-private`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};


export const get_doc_details = async (docToken) => {
  try {
    const response = await fetch(`${BASE_URL}documents/${docToken}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      },
      cache: 'no-store',
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_general_doc_details = async (docToken) => {
  try {
    const response = await fetch(`${BASE_URL}general-documents/${docToken}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      },
      cache: 'no-store',
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_link_details = async (linkCode) => {
  try {
    const response = await fetch(`${BASE_URL}links/${linkCode}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
      },
      cache: 'no-store',
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const upload_document = async (formData) => {
  try {
    const response = await fetch(`${BASE_URL}documents/upload`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const submit_form = async (endpoint, data) => {
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

// MyInvestment specific API functions
export const get_user_accounts = async (userToken) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    
    const response = await fetch(`${BASE_URL}/customer-accounts`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};
 
export const get_customer_account = async (my_account, userToken) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('ac_name', my_account);
    
    const response = await fetch(`${BASE_URL}/customer-account`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_user_info = async (userToken) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    
    const response = await fetch(`${BASE_URL}/profile`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_account_detail = async (userToken, acName) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('ac_name', acName);
    
    const response = await fetch(`${BASE_URL}/customer-account`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_myinvestments = async (userToken) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    
    const response = await fetch(`${BASE_URL}/get-myinvestments`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_general_docs = async (userToken, refId, tType, search) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('ref_id', refId);
    formData.append('t_type', tType);
    formData.append('search', search);
    
    const response = await fetch(`${BASE_URL}/general-docs`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

// MyInvestment specific API functions
export const get_myinv_basic_info = async (userToken, myinvId) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('myinv_id', myinvId);
    
    const response = await fetch(`${BASE_URL}/get-myinvestment-basic`, {
      method: 'POST',
      body: formData,
    }); 
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_myinvestment_documents = async (userToken, myinvId, docType, search) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('myinv_id', myinvId);
    formData.append('doc_type', docType);
    formData.append('search', search);
    
    const response = await fetch(`${BASE_URL}/get-myinvestment-docs`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_myinvestment_interest_payments = async (userToken, myinvId) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('myinv_id', myinvId);
    
    const response = await fetch(`${BASE_URL}myinvestment-interest-payments`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_myinvestment_investment = async (userToken, myinvId) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('myinv_id', myinvId);
    
    const response = await fetch(`${BASE_URL}/get-myinvestment-investment-data`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

// Securities specific API functions
export const get_fund_managers = async (userToken) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    
    const response = await fetch(`${BASE_URL}/get-fund-managers`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_basic_info = async (userToken, fumId) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('fum_id', fumId);
    
    const response = await fetch(`${BASE_URL}/get-securities-basic`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_securities_documents = async (userToken, fumId, docType, search) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('fum_id', fumId);
    formData.append('doc_type', docType);
    formData.append('search', search);
    
    const response = await fetch(`${BASE_URL}/get-securities-docs`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_securities_fees = async (userToken, fumId) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('fum_id', fumId);
    
    const response = await fetch(`${BASE_URL}/get-securities-fees`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_securities_fum = async (userToken, fumId) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('fum_id', fumId);
    
    const response = await fetch(`${BASE_URL}/get-securities-fum-data`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_securities_investors = async (userToken, fumId, search) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('fum_id', fumId);
    formData.append('search', search);
    
    const response = await fetch(`${BASE_URL}/get-securities-investor-data`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_fum_securities = async (userToken, fumId,security_id="") => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('fum_id', fumId);
    
    formData.append('security_id',security_id); 
    const response = await fetch(`${BASE_URL}/get-fum-securities`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_securities_acquisition_basic = async (userToken, fumId) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('fum_id', fumId);
    
    const response = await fetch(`${BASE_URL}/get-securities-acquisition-basic`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

// Investment Advisor Menu API functions
export const get_inv_adv_menu = async (userToken, invId) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('inv_id', invId);
    
    const response = await fetch(`${BASE_URL}/investment-advisor-menu-details`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const participate_inv_adv_menu = async (userToken, invId) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('inv_id', invId);
    
    const response = await fetch(`${BASE_URL}/participate-investment-advisor-menu`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

// Dashboard API function
export const get_dashboard = async (userToken) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    
    const response = await fetch(`${BASE_URL}/dashboard`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

// Beneficiary API functions
export const get_beneficiary = async (userToken, search = '') => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('search', search);
    
    const response = await fetch(`${BASE_URL}/get-beneficiary`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_beneficiary_info = async (userToken, beneficiaryId) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('beneficiary_id', beneficiaryId);
    
    const response = await fetch(`${BASE_URL}/get-beneficiary-info`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_all_countries = async (userToken) => {
  try {
    const formData = new FormData();
    formData.append('',userToken);
    
    const response = await fetch(`${REACT_ADMIN}/api/app-country-list`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};



export const get_beneficiary_list_with_search = async (userToken,search) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('search', search);
    
    const response = await fetch(`${BASE_URL}/get-beneficiary-list`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_beneficiary_list = async (userToken) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    
    const response = await fetch(`${BASE_URL}/get-beneficiary-list`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};


export  const app_bank_accounts = async (userToken) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    
    const response = await fetch(`${BASE_URL}/app-bank-accounts`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};



export const get_customer_cash_ac = async (userToken, exceptFrom = '') => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('except_from', exceptFrom);
    
    const response = await fetch(`${BASE_URL}/customer-cash-accounts`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_customer_securities = async (userToken) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    
    const response = await fetch(`${BASE_URL}/customer-security-accounts`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const currency_list = async (userToken) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    
    const response = await fetch(`${BASE_URL}/get-currency-list`, {
      method: 'POST',
      body: formData,
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};


export const trans_request_cancel = async (userToken, reqType) => {
    try{
      const formData = new FormData();
      formData.append('user_token', userToken);
      formData.append('req_type', reqType);
      const response = await fetch(`${BASE_URL}/trans-request-cancel`, {
        method: 'POST',
        body: formData
      });
      return handleResponse(response);
    }catch(error){
      handleError(error);
    }
};
// Add these form submission APIs to common.js

export const save_trans_request_c1 = async (userToken, formData) => {
  try {
    formData.append('user_token', userToken);
    const response = await fetch(`${BASE_URL}/save-trans-request-c1`, {
      method: 'POST',
      body: formData
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const save_trans_request_c2 = async (userToken, formData) => {
  try {
    formData.append('user_token', userToken);
    const response = await fetch(`${BASE_URL}/save-trans-request-c2`, {
      method: 'POST',
      body: formData
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const save_trans_request_c3 = async (userToken, formData) => {
  try {
    formData.append('user_token', userToken);
    const response = await fetch(`${BASE_URL}/save-trans-request-c3`, {
      method: 'POST',
      body: formData
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const save_trans_request_c4 = async (userToken, formData) => {
  try {
    formData.append('user_token', userToken);
    const response = await fetch(`${BASE_URL}/save-trans-request-c4`, {
      method: 'POST',
      body: formData
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const save_trans_request_c5 = async (userToken, formData) => {
  try {
    formData.append('user_token', userToken);
    const response = await fetch(`${BASE_URL}/save-trans-request-c5`, {
      method: 'POST',
      body: formData
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const trans_request_verify = async (userToken, reqType) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('req_type', reqType);
    
    const response = await fetch(`${BASE_URL}/trans-request-verify`, {
      method: 'POST',
      body: formData
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_active_trans_req_step = async (userToken, reqType) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('req_type', reqType);
    
    const response = await fetch(`${BASE_URL}/active-trans-request`, {
      method: 'POST',
      body: formData
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const get_place_search = async (searchText) => {
  try {
    const formData = new FormData();
    formData.append('place', searchText);
    
    const response = await fetch(`${BASE_URL}/get-place-list`, {
      method: 'POST',
      body: formData
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const switch_b_account = async (userToken, accountType, companyNo) => {
  try {
    const formData = new FormData();
    formData.append('user_token', userToken);
    formData.append('account_type', accountType);
    formData.append('company_no', companyNo);
    
    const response = await fetch(`${BASE_URL}/switch-b-account`, {
      method: 'POST',
      body: formData
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export default {
  get_doc_details,
  get_general_doc_details,
  get_link_details,
  upload_document,
  submit_form,
  get_user_accounts,
  get_user_info,
  get_account_detail,
  get_myinvestments,
  get_general_docs,
  get_myinv_basic_info,
  get_myinvestment_documents,
  get_myinvestment_interest_payments,
  get_myinvestment_investment,
  get_fund_managers,
  get_basic_info,
  get_securities_documents,
  get_securities_fees,
  get_securities_fum,
  get_securities_investors,
  get_fum_securities,
  get_securities_acquisition_basic,
  get_inv_adv_menu,
  participate_inv_adv_menu,
  get_dashboard,
  get_beneficiary,
  get_beneficiary_info,
  get_all_countries,
  // Add the new functions here
  get_customer_cash_ac,
  get_customer_securities,
  currency_list,
  base_url: () => BASE_URL,
  get_beneficiary_list,
  app_bank_accounts,
  get_active_trans_req_step,
  get_place_search,
  switch_b_account,
  save_trans_request_c1,
  save_trans_request_c2,
  save_trans_request_c3,
  save_trans_request_c4,
  save_trans_request_c5,
  trans_request_cancel,
  trans_request_verify,
  is_approval_valid,
  esign_request_details,
  base_url : () => BASE_URL,
};

// Add these functions to common.js

export const save_trans_request_d1 = async (userToken, formData) => {
  try {
    formData.append('user_token', userToken);
    const response = await fetch(`${BASE_URL}/save-trans-request-d1`, {
      method: 'POST',
      body: formData
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const save_trans_request_d2 = async (userToken, formData) => {
  try {
    formData.append('user_token', userToken);
    const response = await fetch(`${BASE_URL}/save-trans-request-d2`, {
      method: 'POST',
      body: formData
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const save_trans_request_d3 = async (userToken, formData) => {
  try {
    formData.append('user_token', userToken);
    const response = await fetch(`${BASE_URL}/save-trans-request-d3`, {
      method: 'POST',
      body: formData
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const save_trans_request_d4 = async (userToken, formData) => {
  try {
    formData.append('user_token', userToken);
    const response = await fetch(`${BASE_URL}/save-trans-request-d4`, {
      method: 'POST',
      body: formData
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};

export const save_trans_request_d5 = async (userToken, formData) => {
  try {
    formData.append('user_token', userToken);
    const response = await fetch(`${BASE_URL}/save-trans-request-d5`, {
      method: 'POST',
      body: formData
    });
    return handleResponse(response);
  } catch (error) {
    handleError(error);
  }
};
